/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  Typography,
  IconButton,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";
import Link from "@mui/material/Link";
import axios from "axios";
import { API } from "../../pages/backend";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import data from "../dropDown";
import Swal from "sweetalert2";

import Spinner from "../ui/Spinner";
import { useDispatch } from "react-redux";
import { loggedInUser, setUser } from "../../store/reducers/user";
import FormButton from "../ui/button/FormButton";
import InputField from "../forms/input/TextInput/InputField";
import { apiRequest } from "../../services/auth";
import FileDownloadIcon from "@mui/icons-material/FileDownload"; // MUI Download Icon
import ContentCopyIcon from "@mui/icons-material/ContentCopy"; // MUI Copy Icon

import { closeModal, showModal } from "../../store/reducers/modal";

const RegisterFormBeceCas = ({
  serviceType,
  examType = "BECE EXAMINATION",
  navigateTo,
}) => {
  const formSchema = yup.object().shape({
    schoolCode: yup.string().required("School Code is Required"),
    firstName: yup
      .string()
      .required("First Name is Required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "First Name should not contain numbers"),
    lastName: yup
      .string()
      .required("Last Name is Required")
      .matches(/^[A-Za-z]+(-[A-Za-z]+)*$/, "Last Name should not contain numbers"),
    email: yup
      .string()
      .required("Email can't be Empty")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalid email address"
      ),
    phoneNumber: yup
      .string()
      .required("Phone Number is required")
      .matches(/^[0-9]{11}$/, "Please input a valid phone number"),
    // payerId: yup.string().required("Payer ID is required"),

    password: yup
      .string()
      .required("Password is Required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
    confirm: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is Required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
  });

  const [loading, setLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  // const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [school, setSchool] = useState("");
  const [schoolArr, setSchoolArr] = useState([]);
  const [open, setOpen] = useState(false);



  // const { Lga } = data;

  const {
    setValue,
    // handleSubmit,
    formState: { errors },
    // trigger,
    watch,
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const schoolCode = useMemo(() => watch()?.schoolCode, [watch()?.schoolCode]);

  const fetchSchoolsBySchoolCode = async () => {
    
    const getSchoolsUrl =
      serviceType === "bece"
        ? `/school/04?parameter=${schoolCode}`
        : `/school/03?parameter=${schoolCode}`;
    console.log(getSchoolsUrl);

    try {
      setCodeLoading(true);

      const response = await axios.get(`${API}${getSchoolsUrl}`);
      console.log(response);

      if (response?.data?.status === "success") {
        console.log(response.data.data.details.rows);
        console.log(response?.data.status);
        console.log(response.data.data.details);
        setSchoolArr(response?.data?.data?.details?.rows?.[0]);
        console.log(schoolArr);
        console.log(schoolArr.schoolType);

        toast.success("School details retrieved successfully");
      }
    } catch (error) {
      toast.error("Unable to retrieve school details, try again later");
      console.log(error);
    } finally {
      setCodeLoading(false);
    }
  };

  const isDisabled = useMemo(() => {
    const {
      // firstName,
      // lastName,
      // email,
      // phoneNumber,
      // password,
      // confirm,
      schoolCode,
    } = watch();

    let bool =
      // firstName &&
      // lastName &&
      // email &&
      // password &&
      // confirm &&
      // phoneNumber?.length === 11 &&
      // password === confirm &&
      schoolCode;
    // console.log(bool)
    // const isValid =  trigger();
    // if (!isValid) return
    return !bool;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolCode, watch()]);

  useEffect(() => {
    if (schoolCode?.length > 5) {
      fetchSchoolsBySchoolCode();
    } else {
      console.log("first");
      setSchoolArr([]);
    }

    // return () => {
    //   schoolCode({})
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolCode]);

  const Register = async () => {
    if (schoolArr?.length === 0) {
      return;
    }
  
    const submitUrl =
      serviceType === "bece"
        ? `/user/schoolUser-reg/${schoolCode}/04`
        : `/user/schoolUser-reg/${schoolCode}/03`;
  
    let value = watch();
    console.log(value);
  
    try {
      setLoading(true);
      console.log(schoolCode);
      delete value.schoolCode;
  
      const res = await apiRequest({
        method: "post",
        url: submitUrl,
        payload: value,
        successMessage: " ",
        showError: true,
        dispatchFunct: dispatch(closeModal(<></>)),
      });
  
      if (res?.data?.status === "success") {
        // Extract school credentials
        const { schoolId, password } = res?.data?.data?.details || {};
  
        // Call functions for confirmation and automatic download
        registerConfirm(schoolId, password);
        downloadCredentials(schoolId, password);
  
        Swal.fire({
          title: "Successful",
          html: `
            <p>Registration successful! Login with the account you just registered to continue.</p>
            <p style="font-weight: bold; color: green;">Your credentials have been downloaded to your device.</p>
          `,
          icon: "success",
          confirmButtonText: "Ok",
        });
  
        navigate();
        console.log(res?.data?.data);
        dispatch(setUser(res?.data?.data));
      } else if (res?.data?.status === "failed") {
        Swal.fire({
          title: "Error",
          text: res?.data?.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error",
        text: "School user already exists",
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setLoading(false);
    }
  };
  
  

  
  // Function to download credentials
  const downloadCredentials = (username, password) => {
    const data = `Username: ${username}\nPassword: ${password}`;
    const blob = new Blob([data], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "credentials.txt"; // The filename for the download
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  

  // const registerConfirm = () => {
  //   let value = watch();
  //   trigger().then((isValid) => {
  //     if (!isValid) return;
  //   });

  //   dispatch(
  //     showModal({
  //       content: (
  //         <div
  //           style={{ display: "flex", flexDirection: "column", gap: "24px" }}
  //         >
  //           <Typography
  //             style={{
  //               display: "flex",
  //               fontSize: "18px",
  //               fontWeight: "bold",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               marginTop: "10px",
  //               textAlign: 'center'
  //             }}
  //           >
  //             Please confirm your details before proceeding
  //           </Typography>

  //           <div
  //             style={{
  //               display: "flex",
  //               flexDirection: "column",
  //               fontSize: "18px",
  //               fontWeight: "bold",
  //               alignItems: "start",
  //               justifyContent: "center",
  //               marginTop: "5px",
  //             }}
  //           >
  //             <Typography>
  //               {" "}
  //               Name:{" "}
  //               <span style={{ fontWeight: "bold" }}>
  //                 {value?.firstName} {value?.lastName}
  //               </span>
  //             </Typography>
  //             <Typography>
  //               Email:{" "}
  //               <span style={{ fontWeight: "bold" }}>{value?.email}</span>
  //             </Typography>
  //             <Typography>
  //               PhoneNumber:{" "}
  //               <span style={{ fontWeight: "bold" }}>{value?.phoneNumber}</span>
  //             </Typography>
  //             <Typography>
  //               School Code:{" "}
  //               <span style={{ fontWeight: "bold" }}>{value?.schoolCode}</span>
  //             </Typography>
  //             <Typography>
  //               School Type:{" "}
  //               <span style={{ fontWeight: "bold" }}>
  //                 {schoolArr?.schoolType}
  //               </span>
  //             </Typography>
  //             <Typography>
  //               School Name:{" "}
  //               <span style={{ fontWeight: "bold" }}>
  //                 {schoolArr?.schoolName}
  //               </span>
  //             </Typography>
  //             <Typography>
  //               LGA:{" "}
  //               <span style={{ fontWeight: "bold" }}>{schoolArr?.lga}</span>
  //             </Typography>
  //           </div>

  //           <Box
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               gap: "5px",
  //               // justifyContent: "space-between",
  //               // flexWrap:'wrap'
  //             }}
  //           >
  //             <FormButton
  //               label={"Cancel"}
  //               width="medium"
  //               onClick={() => dispatch(closeModal(<></>))}
  //             />
  //             <FormButton
  //               label={loading ? <Spinner width="5%" /> : "Proceed"}
  //               width="medium"
  //               onClick={() => Register()}
  //               type="submit"
  //             />
  //           </Box>
  //         </div>
  //       ),
  //     })
  //   );
  // };

  // Function to handle registration confirmation rtake bece
  const registerConfirm = (username, password) => {
   

    dispatch(
      showModal({
        content: (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <Typography
              style={{
                display: "flex",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              Please confirm your details before proceeding
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: "18px",
                fontWeight: "bold",
                alignItems: "start",
                justifyContent: "center",
                marginTop: "5px",
              }}
            >
              {/* Username with Copy Button */}
              <Typography>
                Username: <span style={{ fontWeight: "bold" }}>{username}</span>
                <IconButton
                  size="small"
                  onClick={() => navigator.clipboard.writeText(username)}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Typography>

              {/* Password with Copy Button */}
              <Typography>
                Password: <span style={{ fontWeight: "bold" }}>{password}</span>
                <IconButton
                  size="small"
                  onClick={() => navigator.clipboard.writeText(password)}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Typography>

              {/* School Information */}
              <Typography>
                School Code:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {schoolArr?.schoolCode}
                </span>
              </Typography>
              <Typography>
                School Type:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {schoolArr?.schoolType}
                </span>
              </Typography>
              <Typography>
                School Name:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {schoolArr?.schoolName}
                </span>
              </Typography>
              <Typography>
                LGA:{" "}
                <span style={{ fontWeight: "bold" }}>{schoolArr?.lga}</span>
              </Typography>
            </div>

            {/* Cancel and Proceed Buttons */}
            <Box style={{ display: "flex", alignItems: "center", gap: "5px",flexDirection:'row' }}>
             
              {/* <FormButton
                label={"Cancel"}
                width="medium"
                onClick={() => dispatch(closeModal(<></>))}
              /> */}
                 
              {/* Download Button */}
              <FormButton
                label="Download Credentials"
                width="medium"
                onClick={() => downloadCredentials(username, password)}
              />
              <FormButton
                label={loading ? <Spinner width="5%" /> : "Proceed"}
                width="medium"
                type="submit"
                onClick={() => {
                  dispatch(closeModal(<></>)); // Close the modal
                  navigate(navigateTo); // Navigate to the desired route
                }}
              />
          
            </Box>
          </div>
        ),
      })
    );
  };



  const location = useLocation();
  const [loginPage, setLoginPage] = useState(null);

  useEffect(() => {
    if (location.pathname === "/bece/payment/register") {
      setLoginPage("/bece/payment/login");
    } else if (location.pathname === "/cas/payment/register")
      setLoginPage("/cas/payment/login");
  }, [location.pathname]);

  return (
    <div>
      <Card
        className="register-card"
        style={{
          boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
          // borderRadius: '10px',
        }}
      >
        <Container component="div">
          <Stack style={{ textAlign: "center" }}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              EXAM PORTAL REGISTRATION
            </Typography>
            <Typography variant="subtitle5" style={{ padding: "12px" }}>
              {" "}
              {examType}{" "}
            </Typography>
          </Stack>
          <div
            style={
              {
                // marginTop: "3rem",
                // padding: "30px 40px",
              }
            }
          >
            <div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputField
                      name="schoolCode"
                      label="School Code"
                      // type="number"
                      // min="0"
                      // inputmode="numeric"
                      placeholder="Enter School Code"
                      // value={address}
                      onChange={(e) => {
                        setValue("schoolCode", e.target.value.trim());
                      }}
                      style={{ height: "100%" }}
                    />

                    <Typography
                      sx={{
                        color: "#e53e3e",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      style={{
                        visibility: errors.schoolCode ? "visible" : "hidden",
                      }}
                    >
                      {errors.schoolCode?.message}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputField
                      name="Local Government Area"
                      label="Local Government Area"
                      type="localGovernmentArea"
                      placeholder="Local Government Area"
                      value={schoolArr?.lga || ""}
                      // onChange={(e) => {
                      //     setValue("schoolCode", e.target.value);
                      // }}
                      style={{ height: "100%" }}
                      readOnly
                    />
                  </Grid>
                </Grid>
              </div>
              {/* newly added input */}
              <div>
                <Grid>
                  <InputField
                    name="School Type"
                    label="School Type"
                    type="schoolType"
                    placeholder="School Type"
                    value={schoolArr?.schoolType || ""}
                    // onChange={(e) => {
                    //     setValue("schoolCode", e.target.value);
                    // }}
                    style={{ height: "100%" }}
                    readOnly
                  />
                </Grid>
              </div>
              <div>
                <Grid>
                  <InputField
                    name="School Name"
                    label="School Name"
                    type="schoolName"
                    placeholder="School Name"
                    value={schoolArr?.schoolName || ""}
                    // onChange={(e) => {
                    //     setValue("schoolCode", e.target.value);
                    // }}
                    style={{ height: "100%" }}
                    readOnly
                  />
                </Grid>
              </div>


              {/* Register Button */}
              <Stack style={{ marginTop: "10px" }}>
                {/* <Grid>
                  <FormButton
                    type="button"
                    label={loading ? <Spinner width="5%" /> : "Register"}
                    disabled={isDisabled || loading}
                    width="full"
                    onClick={registerConfirm}
                  />
                </Grid> */}
                <Grid>
                  <FormButton
                    type="button"
                    label={
                      loading ? (
                        <Spinner width="5%" />
                      ) : (
                        "Generate Password and Username"
                      )
                    }
                    disabled={isDisabled || loading}
                    width="full"
                    onClick={Register}
                  />
                </Grid>
              </Stack>
            </div>
            <Typography
              variant="body2"
              fontWeight="normal"
              marginTop="10px"
              textAlign="center"
              cursor="pointer"
              color="#807c7c"
            >
              Already signed up? {"   "}
              {"   "}
              <Link
                href={loginPage}
                style={{
                  textDecoration: "none",
                  color: "#34A56F",
                }}
              ></Link>
              <Link
                href={loginPage}
                style={{
                  textDecoration: "none",
                  color: "#34A56F",
                }}
              >
                {"  "}
                Login
              </Link>
            </Typography>
            <Typography
              variant="body2"
              fontWeight="bold"
              marginTop="10px"
              textAlign="center"
              cursor="pointer"
              color="secondary"
            >
              <Link
                href="/"
                style={{
                  textDecoration: "none",
                  color: "#34A56F",
                  fontWeight: "normal",
                }}
              >
                Back to home page
              </Link>
            </Typography>
          </div>
          {/* <Footer /> */}
        </Container>
      </Card>
    </div>
  );
};

export default RegisterFormBeceCas;

// /* eslint-disable no-unused-vars */
// import React, { useMemo } from "react";
// import {
//   Box,
//   Card,
//   Container,
//   Stack,
//   Typography,
//   IconButton,
//   Checkbox,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Grid,
//   Button,
//   MenuItem,
//   TextField,
// } from "@mui/material";
// import { useState, useEffect } from "react";
// import Link from "@mui/material/Link";
// import axios from "axios";
// import { API } from "../../pages/backend";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import { useForm, Controller } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import data from "../dropDown";
// import Swal from "sweetalert2";

// import Spinner from "../ui/Spinner";
// import { useDispatch } from "react-redux";
// import { loggedInUser, setUser } from "../../store/reducers/user";
// import FormButton from "../ui/button/FormButton";
// import InputField from "../forms/input/TextInput/InputField";
// import { apiRequest } from "../../services/auth";
// import FileDownloadIcon from "@mui/icons-material/FileDownload"; // MUI Download Icon
// import ContentCopyIcon from "@mui/icons-material/ContentCopy"; // MUI Copy Icon

// import { closeModal, showModal } from "../../store/reducers/modal";

// const RetakeRegisterFormBeceCas = ({
//   serviceType,
//   examType = "BECE EXAMINATION",
//   navigateTo,
// }) => {
//   const formSchema = yup.object().shape({
//     schoolCode: yup.string().required("School Code is Required"),
//     firstName: yup
//       .string()
//       .required("First Name is Required")
//       .matches(/^[a-zA-Z]*$/, "First Name should not contain numbers"),
//     lastName: yup
//       .string()
//       .required("Last Name is Required")
//       .matches(/^[a-zA-Z]*$/, "Last Name should not contain numbers"),
//     email: yup
//       .string()
//       .required("Email can't be Empty")
//       .matches(
//         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
//         "Invalid email address"
//       ),
//     phoneNumber: yup
//       .string()
//       .required("Phone Number is required")
//       .matches(/^[0-9]{11}$/, "Please input a valid phone number"),
//     // payerId: yup.string().required("Payer ID is required"),

//     password: yup
//       .string()
//       .required("Password is Required")
//       .matches(
//         /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
//         "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
//       ),
//     confirm: yup
//       .string()
//       .oneOf([yup.ref("password"), null], "Passwords must match")
//       .required("Confirm Password is Required")
//       .matches(
//         /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
//         "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
//       ),
//   });

//   const [loading, setLoading] = useState(false);
//   const [codeLoading, setCodeLoading] = useState(false);
//   // const [isDisabled, setIsDisabled] = useState(true);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [school, setSchool] = useState("");
//   const [schoolArr, setSchoolArr] = useState([]);
//   const [open, setOpen] = useState(false);



//   // const { Lga } = data;

//   const {
//     setValue,
//     // handleSubmit,
//     formState: { errors },
//     // trigger,
//     watch,
//   } = useForm({
//     resolver: yupResolver(formSchema),
//   });

//   const schoolCode = useMemo(() => watch()?.schoolCode, [watch()?.schoolCode]);

//   const fetchSchoolsBySchoolCode = async () => {
    
//     const getSchoolsUrl =
//       serviceType === "bece"
//         ? `/school/04?parameter=${schoolCode}`
//         : `/school/03?parameter=${schoolCode}`;
//     console.log(getSchoolsUrl);

//     try {
//       setCodeLoading(true);

//       const response = await axios.get(`${API}${getSchoolsUrl}`);
//       console.log(response);

//       if (response?.data?.status === "success") {
//         console.log(response.data.data.details.rows);
//         console.log(response?.data.status);
//         console.log(response.data.data.details);
//         setSchoolArr(response?.data?.data?.details?.rows?.[0]);
//         console.log(schoolArr);
//         console.log(schoolArr.schoolType);

//         toast.success("School details retrieved successfully");
//       }
//     } catch (error) {
//       toast.error("Unable to retrieve school details, try again later");
//       console.log(error);
//     } finally {
//       setCodeLoading(false);
//     }
//   };

//   const isDisabled = useMemo(() => {
//     const {
//       // firstName,
//       // lastName,
//       // email,
//       // phoneNumber,
//       // password,
//       // confirm,
//       schoolCode,
//     } = watch();

//     let bool =
//       // firstName &&
//       // lastName &&
//       // email &&
//       // password &&
//       // confirm &&
//       // phoneNumber?.length === 11 &&
//       // password === confirm &&
//       schoolCode;
//     // console.log(bool)
//     // const isValid =  trigger();
//     // if (!isValid) return
//     return !bool;
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [schoolCode, watch()]);

//   useEffect(() => {
//     if (schoolCode?.length > 5) {
//       fetchSchoolsBySchoolCode();
//     } else {
//       console.log("first");
//       setSchoolArr([]);
//     }

//     // return () => {
//     //   schoolCode({})
//     // }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [schoolCode]);

//   const Register = async () => {
//     const submitUrl =
//       serviceType === "bece"
//         ? `/user/bece-reg/${schoolCode}/04`
//         : `/user/bece-reg/${schoolCode}/03`;
  
//     let value = watch();
//     console.log(value);
//     // const isValid = await trigger(); // Trigger validation
  
//     // // Do not proceed if there are validation errors
//     // if (!isValid) return;
  
//     // delete value.confirm
//     try {
//       setLoading(true);
//       console.log(schoolCode);
//       delete value.schoolCode;
  
//       const res = await apiRequest({
//         method: "post",
//         url: submitUrl,
//         payload: value,
//         successMessage: " ",
//         showError: true,
//         dispatchFunct: dispatch(closeModal(<></>)),
//       });
  
//       if (res?.data?.status === "success") {
        
//         // alert(res.data.data.details.schoolId) 

//         // alert(res.data.data.details.password)
//         // Get the username and password from the response
//         const { schoolId, password } = res?.data?.data?.details || {};

//         registerConfirm(schoolId, password)
//         // Automatically download the credentials upon registration
//         downloadCredentials(schoolId, password);
        
  
//         Swal.fire({
//           title: "Successful",
//           text: "Registration successful! Login with the account you just registered to continue.",
//           icon: "success",
//           confirmButtonText: "Ok",
//         });
  
//         console.log(res?.data?.data);
//         dispatch(setUser(res?.data?.data));
//       } else if (res?.data?.status === "failure") {
//         Swal.fire({
//           title: "Error",
//           text: res?.data?.message,
//           icon: "error",
//           confirmButtonText: "Ok",
//         });
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };
  

  
//   // Function to download credentials
//   const downloadCredentials = (username, password) => {
//     const data = `Username: ${username}\nPassword: ${password}`;
//     const blob = new Blob([data], { type: "text/plain" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "credentials.txt"; // The filename for the download
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };
  

//   // const registerConfirm = () => {
//   //   let value = watch();
//   //   trigger().then((isValid) => {
//   //     if (!isValid) return;
//   //   });

//   //   dispatch(
//   //     showModal({
//   //       content: (
//   //         <div
//   //           style={{ display: "flex", flexDirection: "column", gap: "24px" }}
//   //         >
//   //           <Typography
//   //             style={{
//   //               display: "flex",
//   //               fontSize: "18px",
//   //               fontWeight: "bold",
//   //               alignItems: "center",
//   //               justifyContent: "center",
//   //               marginTop: "10px",
//   //               textAlign: 'center'
//   //             }}
//   //           >
//   //             Please confirm your details before proceeding
//   //           </Typography>

//   //           <div
//   //             style={{
//   //               display: "flex",
//   //               flexDirection: "column",
//   //               fontSize: "18px",
//   //               fontWeight: "bold",
//   //               alignItems: "start",
//   //               justifyContent: "center",
//   //               marginTop: "5px",
//   //             }}
//   //           >
//   //             <Typography>
//   //               {" "}
//   //               Name:{" "}
//   //               <span style={{ fontWeight: "bold" }}>
//   //                 {value?.firstName} {value?.lastName}
//   //               </span>
//   //             </Typography>
//   //             <Typography>
//   //               Email:{" "}
//   //               <span style={{ fontWeight: "bold" }}>{value?.email}</span>
//   //             </Typography>
//   //             <Typography>
//   //               PhoneNumber:{" "}
//   //               <span style={{ fontWeight: "bold" }}>{value?.phoneNumber}</span>
//   //             </Typography>
//   //             <Typography>
//   //               School Code:{" "}
//   //               <span style={{ fontWeight: "bold" }}>{value?.schoolCode}</span>
//   //             </Typography>
//   //             <Typography>
//   //               School Type:{" "}
//   //               <span style={{ fontWeight: "bold" }}>
//   //                 {schoolArr?.schoolType}
//   //               </span>
//   //             </Typography>
//   //             <Typography>
//   //               School Name:{" "}
//   //               <span style={{ fontWeight: "bold" }}>
//   //                 {schoolArr?.schoolName}
//   //               </span>
//   //             </Typography>
//   //             <Typography>
//   //               LGA:{" "}
//   //               <span style={{ fontWeight: "bold" }}>{schoolArr?.lga}</span>
//   //             </Typography>
//   //           </div>

//   //           <Box
//   //             style={{
//   //               display: "flex",
//   //               alignItems: "center",
//   //               gap: "5px",
//   //               // justifyContent: "space-between",
//   //               // flexWrap:'wrap'
//   //             }}
//   //           >
//   //             <FormButton
//   //               label={"Cancel"}
//   //               width="medium"
//   //               onClick={() => dispatch(closeModal(<></>))}
//   //             />
//   //             <FormButton
//   //               label={loading ? <Spinner width="5%" /> : "Proceed"}
//   //               width="medium"
//   //               onClick={() => Register()}
//   //               type="submit"
//   //             />
//   //           </Box>
//   //         </div>
//   //       ),
//   //     })
//   //   );
//   // };

//   // Function to handle registration confirmation rtake bece
//   const registerConfirm = (username, password) => {
   

//     dispatch(
//       showModal({
//         content: (
//           <div
//             style={{ display: "flex", flexDirection: "column", gap: "24px" }}
//           >
//             <Typography
//               style={{
//                 display: "flex",
//                 fontSize: "18px",
//                 fontWeight: "bold",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 marginTop: "10px",
//                 textAlign: "center",
//               }}
//             >
//               Please confirm your details before proceeding
//             </Typography>

//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 fontSize: "18px",
//                 fontWeight: "bold",
//                 alignItems: "start",
//                 justifyContent: "center",
//                 marginTop: "5px",
//               }}
//             >
//               {/* Username with Copy Button */}
//               <Typography>
//                 Username: <span style={{ fontWeight: "bold" }}>{username}</span>
//                 <IconButton
//                   size="small"
//                   onClick={() => navigator.clipboard.writeText(username)}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Typography>

//               {/* Password with Copy Button */}
//               <Typography>
//                 Password: <span style={{ fontWeight: "bold" }}>{password}</span>
//                 <IconButton
//                   size="small"
//                   onClick={() => navigator.clipboard.writeText(password)}
//                 >
//                   <ContentCopyIcon fontSize="small" />
//                 </IconButton>
//               </Typography>

//               {/* School Information */}
//               <Typography>
//                 School Code:{" "}
//                 <span style={{ fontWeight: "bold" }}>
//                   {schoolArr?.schoolCode}
//                 </span>
//               </Typography>
//               <Typography>
//                 School Type:{" "}
//                 <span style={{ fontWeight: "bold" }}>
//                   {schoolArr?.schoolType}
//                 </span>
//               </Typography>
//               <Typography>
//                 School Name:{" "}
//                 <span style={{ fontWeight: "bold" }}>
//                   {schoolArr?.schoolName}
//                 </span>
//               </Typography>
//               <Typography>
//                 LGA:{" "}
//                 <span style={{ fontWeight: "bold" }}>{schoolArr?.lga}</span>
//               </Typography>
//             </div>

//             {/* Cancel and Proceed Buttons */}
//             <Box style={{ display: "flex", alignItems: "center", gap: "5px",flexDirection:'row' }}>
             
//               {/* <FormButton
//                 label={"Cancel"}
//                 width="medium"
//                 onClick={() => dispatch(closeModal(<></>))}
//               /> */}
                 
//               {/* Download Button */}
//               <FormButton
//                 label="Download Credentials"
//                 width="medium"
//                 onClick={() => downloadCredentials(username, password)}
//               />
//               <FormButton
//                 label={loading ? <Spinner width="5%" /> : "Proceed"}
//                 width="medium"
//                 type="submit"
//                 onClick={() => {
//                   dispatch(closeModal(<></>)); // Close the modal
//                   navigate(navigateTo); // Navigate to the desired route
//                 }}
//               />
          
//             </Box>
//           </div>
//         ),
//       })
//     );
//   };

//   // // Function to download username and password as a text file
//   // const downloadCredentials = (username, password) => {
//   //   const fileData = `Username: ${username}\nPassword: ${password}`;
//   //   const blob = new Blob([fileData], { type: "text/plain" });
//   //   const url = URL.createObjectURL(blob);
//   //   const a = document.createElement("a");
//   //   a.href = url;
//   //   a.download = "user_credentials.txt";
//   //   document.body.appendChild(a);
//   //   a.click();
//   //   document.body.removeChild(a);
//   // };

//   const location = useLocation();
//   const [loginPage, setLoginPage] = useState(null);

//   useEffect(() => {
//     if (location.pathname === "/bece/payment/register") {
//       setLoginPage("/bece/payment/login");
//     } else if (location.pathname === "/cas/payment/register")
//       setLoginPage("/cas/payment/login");
//   }, [location.pathname]);

//   return (
//     <div>
//       <Card
//         className="register-card"
//         style={{
//           boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
//           // borderRadius: '10px',
//         }}
//       >
//         <Container component="div">
//           <Stack style={{ textAlign: "center" }}>
//             <Typography variant="h5" style={{ fontWeight: "bold" }}>
//               EXAM PORTAL REGISTRATION
//             </Typography>
//             <Typography variant="subtitle5" style={{ padding: "12px" }}>
//               {" "}
//               {examType}{" "}
//             </Typography>
//           </Stack>
//           <div
//             style={
//               {
//                 // marginTop: "3rem",
//                 // padding: "30px 40px",
//               }
//             }
//           >
//             <div>
//               <div>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={6}>
//                     <InputField
//                       name="schoolCode"
//                       label="School Code"
//                       // type="number"
//                       // min="0"
//                       // inputmode="numeric"
//                       placeholder="Enter School Code"
//                       // value={address}
//                       onChange={(e) => {
//                         setValue("schoolCode", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />

//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.schoolCode ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.schoolCode?.message}
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <InputField
//                       name="Local Government Area"
//                       label="Local Government Area"
//                       type="localGovernmentArea"
//                       placeholder="Local Government Area"
//                       value={schoolArr?.lga || ""}
//                       // onChange={(e) => {
//                       //     setValue("schoolCode", e.target.value);
//                       // }}
//                       style={{ height: "100%" }}
//                       readOnly
//                     />
//                   </Grid>
//                 </Grid>
//               </div>
//               {/* newly added input */}
//               <div>
//                 <Grid>
//                   <InputField
//                     name="School Type"
//                     label="School Type"
//                     type="schoolType"
//                     placeholder="School Type"
//                     value={schoolArr?.schoolType || ""}
//                     // onChange={(e) => {
//                     //     setValue("schoolCode", e.target.value);
//                     // }}
//                     style={{ height: "100%" }}
//                     readOnly
//                   />
//                 </Grid>
//               </div>
//               <div>
//                 <Grid>
//                   <InputField
//                     name="School Name"
//                     label="School Name"
//                     type="schoolName"
//                     placeholder="School Name"
//                     value={schoolArr?.schoolName || ""}
//                     // onChange={(e) => {
//                     //     setValue("schoolCode", e.target.value);
//                     // }}
//                     style={{ height: "100%" }}
//                     readOnly
//                   />
//                 </Grid>
//               </div>

//               {/* real exam */}
//               {/* <div>
//                 <Grid container spacing={2}>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="firstName"
//                       label="First Name"
//                       type="firstName"
//                       placeholder="First Name"
//                       // value={firstName}
//                       onChange={(e) => {
//                         setValue("firstName", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.firstName ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.firstName?.message}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="lastName"
//                       label="Last Name"
//                       type="lastName"
//                       placeholder="Last Name"
//                       // value={lastName}
//                       onChange={(e) => {
//                         setValue("lastName", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.lastName ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.lastName?.message}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </div>
//               <div>
//                 <Grid container spacing={2}>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="email"
//                       label="Email"
//                       type="email"
//                       placeholder="Email"
//                       // value={email}
//                       onBlur={() => trigger("email")}
//                       onChange={(e) => {
//                         setValue("email", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.email ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.email?.message}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="phoneNumber"
//                       label="Phone Number"
//                       type="phoneNumber"
//                       placeholder="Phone Number"
//                       onBlur={() => trigger("phoneNumber")}
//                       // value={phone}
//                       onChange={(e) => {
//                         setValue("phoneNumber", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.phoneNumber ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.phoneNumber?.message}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </div>

//               <div>
//                 <Grid container spacing={2}>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="password"
//                       label="Password"
//                       type="password"
//                       placeholder="Password"
//                       onBlur={() => trigger("password")}
//                       // value={password}
//                       password
//                       onChange={(e) => {
//                         setValue("password", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.password ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.password?.message}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <InputField
//                       name="confirm"
//                       label=" Confirm Password"
//                       type="confirmPassword"
//                       placeholder=" Confirm Password"
//                       password
//                       // value={confirmPassword}
//                       onBlur={() => trigger("confirm")}
//                       onChange={(e) => {
//                         setValue("confirm", e.target.value);
//                       }}
//                       style={{ height: "100%" }}
//                     />
//                     <Typography
//                       sx={{
//                         color: "#e53e3e",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                       }}
//                       style={{
//                         visibility: errors.confirm ? "visible" : "hidden",
//                       }}
//                     >
//                       {errors.confirm?.message}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </div> */}

//               {/* Register Button */}
//               <Stack style={{ marginTop: "10px" }}>
//                 {/* <Grid>
//                   <FormButton
//                     type="button"
//                     label={loading ? <Spinner width="5%" /> : "Register"}
//                     disabled={isDisabled || loading}
//                     width="full"
//                     onClick={registerConfirm}
//                   />
//                 </Grid> */}
//                 <Grid>
//                   <FormButton
//                     type="button"
//                     label={
//                       loading ? (
//                         <Spinner width="5%" />
//                       ) : (
//                         "Generate Password and Username"
//                       )
//                     }
//                     disabled={isDisabled || loading}
//                     width="full"
//                     onClick={Register}
//                   />
//                 </Grid>
//               </Stack>
//             </div>
//             <Typography
//               variant="body2"
//               fontWeight="normal"
//               marginTop="10px"
//               textAlign="center"
//               cursor="pointer"
//               color="#807c7c"
//             >
//               Already signed up? {"   "}
//               {"   "}
//               <Link
//                 href={loginPage}
//                 style={{
//                   textDecoration: "none",
//                   color: "#34A56F",
//                 }}
//               ></Link>
//               <Link
//                 href={loginPage}
//                 style={{
//                   textDecoration: "none",
//                   color: "#34A56F",
//                 }}
//               >
//                 {"  "}
//                 Login
//               </Link>
//             </Typography>
//             <Typography
//               variant="body2"
//               fontWeight="bold"
//               marginTop="10px"
//               textAlign="center"
//               cursor="pointer"
//               color="secondary"
//             >
//               <Link
//                 href="/"
//                 style={{
//                   textDecoration: "none",
//                   color: "#34A56F",
//                   fontWeight: "normal",
//                 }}
//               >
//                 {"  "}
//                 Back to home page
//               </Link>
//             </Typography>
//           </div>
//           {/* <Footer /> */}
//         </Container>
//       </Card>
//     </div>
//   );
// };

// export default RetakeRegisterFormBeceCas;

